// extracted by mini-css-extract-plugin
export default {"actions":"SignUpFooter_actions__6djp+","button":"SignUpFooter_button__cFKri","link":"SignUpFooter_link__Rezct"};